import { Dictionary } from "../../../utils/sys/Dictionary";
import KeyedValueSorter from "./KeyedValueSorter";
import Trait from "../../../utils/game/mechanics/Trait";

export type SortKey = "title" | "subtype" | "cost" | "description";

export default class TraitSorter extends KeyedValueSorter {
    protected static override valueGetters = new Dictionary<SortKey, (trait: Trait) => string | number>([
        { key: "title", value: (trait) => trait.title },
        { key: "subtype", value: (trait) => trait.subtype },
        { key: "cost", value: (trait) => trait.cost },
        { key: "description", value: (trait) => trait.description }
    ]);
}
